import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { NetOutturnListing, NetOutturnAddEdit } from './Pages';

export const NetOutturnRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={NetOutturnListing} />
        <Route exact path = {`${match.path}/AddEdit`} component={NetOutturnAddEdit} />
    </Fragment>
)